import { base } from "@/common/js/base"; //公共js
import axios from 'axios'
import { Message } from 'element-ui'
import qs from 'qs'
import router from '../router/index.js'; //路由
import { apiUrl, cntextPath } from "./requestUrl"

/**
 * 用axios发送请求时，后台保存了session，但是在前台每次刷新页面的时候，发现从后端请求到的session值每次都不一样。
 * 把默认配置withCredentials改为true，就可以允许跨域携带cookie信息了。
 */
axios.defaults.withCredentials = true; //携带cookie
//解决axios请求超时-start
axios.defaults.retry = 2;  //设置全局的请求次数
axios.defaults.retryDelay = 1000;  //设置全局请求的间隙


axios.defaults.timeout = 300 * 1000;
//axios拦截器
axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
    var config = err.config;
    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) return Promise.reject(err);

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;

    // Check if we've maxed out the total number of retries
    if (config.__retryCount >= config.retry) {
        // Reject with the error
        return Promise.reject(err);
    }

    // Increase the retry count
    config.__retryCount += 1;

    // Create new promise to handle exponential backoff
    var backoff = new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, config.retryDelay || 1);
    });

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function () {
        return axios(config);
    });
});

//api 拦截的api
//fn 执行的方法
//implement是否往下执行
const $isMember = '/api/member/isMember';
const getIsMember = async function () {
    let storage = new base().base_localStorage.get($isMember);
    if (storage) {
        return await storage.data;
    } else {
        let url = apiUrl + cntextPath + $isMember;
        let res = await axios({ method: 'get', url: url });
        if (res.status == 200) {
            if (res.data.data && res.data.data != 2) {
                new base().base_localStorage.set({ key: api, time: (6 * 80), data: res.data })
            }
            return res.data;
        } else {
            Message({
                message: res.data.msg,
                type: "error"
            });
        }
    }
}
let $interceptList =
    [
        { api: '/api/ztb/info/getInfoByInfoVO', fn: intercept_getInfoByInfoVO, implement: true },
        // { api: '/api/ztb/infoContent/getContentByInfoId', fn: intercept_getContentByInfoId, implement: true },
        { api: $isMember, fn: intercept_isMember, implement: false },
        { api: '/api/login/phoneLogin', fn: removerLocalStorage, implement: true },
        { api: '/api/qrCode/loginStatus', fn: removerLocalStorage, implement: true },
        { api: '/api/login/exit', fn: () => { localStorage.clear() }, implement: true }
    ];
//登录前清除会员状态缓存
function removerLocalStorage() {
    localStorage.removeItem($isMember);
}

function removerAllLocalStorage() {

}

//拦截 /api/member/isMember，缓存下会员状态
//逻辑为非会员不缓存，会员才缓存;
async function intercept_isMember(api, method, data, then, fail, complete, loginStatus, i) {
    let storage = new base().base_localStorage.get(api);
    if (storage) {
        await then(storage.data);
    } else {
        let url = apiUrl + cntextPath + api;
        let res = await axios({ method: method, url: url });
        if (res.status == 200) {
            if (res.data.data && res.data.data != 2) {
                new base().base_localStorage.set({ key: api, time: (6 * 80), data: res.data })
            }
            await then(res.data);
        } else {
            Message({
                message: res.data.msg,
                type: "error"
            });
        }
    }
}


//拦截  /api/ztb/infoContent/getContentByInfoId
async function intercept_getContentByInfoId(api, method, data, then, fail, complete, loginStatus, i) {
    let res = await getIsMember();
    if (res) {
        if (res.data == 0 || res.data == 2) {//拦截非PC端会员
            if (data && data.infoId) {
                let isBrowse = await browseLimitDate({ key: api, countMax: 4, val: data.infoId });
                i.implement = isBrowse ? false : true;
                if (i.implement == false) {
                    await then(false);
                }
            }
        }
    }
}


//拦截  /api/ztb/info/getInfoByInfoVO
async function intercept_getInfoByInfoVO(api, method, data, then, fail, complete, loginStatus, i) {
    return
    let res = await getIsMember();
    if (res) {
        if (res.data == 0 || res.data == 2) {//拦截非PC端会员
            let isBrowse = await browseLimitDate({ key: api, countMax: 2, val: (data.paramSearchkey || '') });
            i.implement = isBrowse ? false : true;
            if (i.implement == false) {
                Message({
                    message: '非PC端会员1次/天搜索次数已用完，可开通钻石会员/年会员/企业会员不限次数搜索、无遮掩浏览、标讯分析/企业分析等。',
                    type: "error",
                    duration: 5000,
                    showClose: true,
                });
                router.push({ name: 'index', params: { getInfoByInfoVOKey: -2 } });
            }
        }
    }
}

//返回每天某某量是否已上限  true:是
//isCount是否计次
//repeat 重复是否计次
//count 最多浏览次数从0开始
function browseLimitDate({ isCount = true, repeat = true, countMax = 4, key, val } = {}) {
    if (!key) { console.error('未传值'); return }
    let $localStorageKey_browseLimitDate = key;
    let $browseLimitCount = countMax;
    let storage = localStorage.getItem($localStorageKey_browseLimitDate);
    let infoId = val;
    storage = JSON.parse(storage);
    if (storage != null) {
        if (storage.date != new base().getLocalTime(new Date())) {
            storage = null;
        }
    }
    if (isCount) {
        if (storage == null) {
            let browseLimit = { date: new base().getLocalTime(new Date()), count: 1, browseList: [infoId] };
            localStorage.setItem($localStorageKey_browseLimitDate, JSON.stringify(browseLimit))
        } else {
            if (storage.browseList.length > $browseLimitCount) {
                return true;
            }
            if (repeat) {
                storage.browseList.push(infoId);
            } else {
                let isLookup = false;
                for (let i of storage.browseList) {
                    if (i == infoId) { isLookup = true; break; }
                }
                if (isLookup == false) {
                    storage.browseList.push(infoId);
                }
            }
            localStorage.setItem($localStorageKey_browseLimitDate, JSON.stringify(storage))
        }
    } else {
        if (storage == null) {
            return false;
        }
        if (storage.browseList.length > $browseLimitCount) {
            return true;
        } else {
            return false;
        }
    }
}

/**
 * 通用请求方法
 * url : 地址
 * method : 'post' , 'get'
 * data : 请求数据(只接收字符串)
 * then : 请求成功后调用
 * fail : 请求失败后调用
 * complete : 请求完成后调用
 * @param {*} param0
 */
async function requestApi({ url, method, data, qsFormat = true, then, fail, complete, loginStatus }) {
    /* 相关拦截 */
    for (let i of $interceptList) {
        if (url.indexOf(i.api) != -1) {
            await i.fn(i.api, method, data, then, fail, complete, loginStatus, i);
            if (i.implement == false) return;
        }
    }
    /* 相关拦截End */


    if (data == null) {
        data = {};
    }

    // 处理空值
    var keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
        if (keys[i] === null || keys[i] === undefined || keys[i] === "null" || keys[i] === "undefined") {
            delete data[keys[i]];
        }
    }

    url = cntextPath + url
    // console.log("url:"+url)
    // 处理get请求的参数
    if (method.toLocaleLowerCase() === "get" && Object.keys(data).length > 0) {
        let leng = url.length;
        if (url.substring(leng - 1, leng) !== "?") {
            url = url + "?";
        }

        var keys = Object.keys(data)
        for (let i = 0; i < keys.length; i++) {
            url = url + keys[i] + "=" + encodeURIComponent(data[keys[i]]) + (i === keys.length - 1 ? "" : "&")
        }
    }

    // url = encodeURI(url)
    // debugger
    let tempAxiosData = data;
    if (qsFormat) {
        tempAxiosData = qs.stringify(data);
    }
    axios({
        method: method,
        url: url,
        data: tempAxiosData,
        timeout: 300000 // 5分钟
    }).then((response) => {
        // console.log(response)
        // code === 0 成功
        if (response.data.code === 0) {
            if (then != null) {
                then(response.data)
            }
        } else if (response.data.code === -1001) {
            var url = location.href;
            if (url.indexOf('appId') != -1) {
                console.log('需要登录898:' + url);
                //有appId，跳转去登录
                location.href = apiUrl + cntextPath + '/api/authLogin/login?url=' + encodeURIComponent(url)
            }
            // 需要登录
            if (loginStatus != null) {
                loginStatus(response, true)
                if (fail != null) {
                    fail(response)
                }
            } else {
                // location.href = location.origin + location.pathname + "#/index"
                if (location.href.indexOf("index") === -1) {
                    location.href = location.protocol + "//" + location.host + location.pathname + "#/index"
                }

            }
        } else if (response.data.code === -1002) {
            // 被逼下线
            document.cookie = "umxhCookie=''"
            location.href = location.protocol + "//" + location.host + location.pathname + "#/index?restLogin=true"
        }
        else if (response.data.code === -1) {
            //elementUI提供的提示框
            Message({
                message: response.data.msg,
                type: "error"
            });

            // code 等于其他为错误
            if (fail != null) {
                fail(response)
            }
        }
        else {
            // code 等于其他为错误
            if (fail != null) {
                fail(response)
            }
        }

        if (complete != null) {
            complete(response.data);
        }
    }).catch((error) => {
        //elementUI提供的提示框
        console.log(error)
        // Message({
        //     message: "系统错误",
        //     type: "error"
        // });

        if (fail != null) {
            fail(error)
        }

        if (complete != null) {
            complete(error);
        }
    })
}


/**
 * 通用请求方法
 * url : 地址
 * method : 'post' , 'get'
 * data : 请求数据(可传数组)
 * successFn : 请求成功后调用
 * errorFn : 请求失败后调用
 * complete : 请求完成后调用
 * @param {*} param0
 */
function ajax({ url, method, data, successFn, errorFn, complete, loginStatus }) {

    if (data == null) {
        data = {};
    }
    if ("post" == method) {
        if (data != null && !(data instanceof URLSearchParams) && data instanceof Object) {
            var tempData = new URLSearchParams()
            for (const key in data) {
                tempData.append(key, (data[key] == undefined ? '' : data[key]))
            }
            data = tempData;
        }
    }

    url = cntextPath + url
    // console.log("url:"+url)
    // 处理get请求的参数
    if (method.toLocaleLowerCase() === "get" && Object.keys(data).length > 0) {
        let leng = url.length;
        if (url.substring(leng - 1, leng) !== "?") {
            url = url + "?";
        }

        var keys = Object.keys(data)
        for (let i = 0; i < keys.length; i++) {
            url = url + keys[i] + "=" + data[keys[i]] + (i === keys.length - 1 ? "" : "&")
        }
    }

    url = encodeURI(url)

    console.log('url', url);

    axios({
        method: method,
        url: url,
        data: data
    }).then((response) => {
        // console.log(response)
        // code === 0 成功
        if (response.data.code === 0) {
            if (successFn != null) {
                successFn(response.data)
            }
        } else if (response.data.code === -1001) {
            // 需要登录
            if (loginStatus != null) {
                loginStatus(response, true)
                if (errorFn != null) {
                    errorFn(response)
                }
            } else {
                // location.href = location.origin + location.pathname + "#/index"
                if (location.href.indexOf("index") === -1) {
                    location.href = location.protocol + "//" + location.host + location.pathname + "#/index"
                }

            }
        } else if (response.data.code === -1002) {
            // 被逼下线
            document.cookie = "umxhCookie=''"
            location.href = location.protocol + "//" + location.host + location.pathname + "#/index?restLogin=true"
        }
        else if (response.data.code === -1) {
            //elementUI提供的提示框
            Message({
                message: response.data.msg,
                type: "error"
            });

            // code 等于其他为错误
            if (errorFn != null) {
                errorFn(response)
            }
        }
        else {
            // code 等于其他为错误
            if (errorFn != null) {
                errorFn(response)
            }
        }

        if (complete != null) {
            complete(response.data);
        }
    }).catch((error) => {
        //elementUI提供的提示框
        console.log(error)
        // Message({
        //     message: "系统错误",
        //     type: "error"
        // });

        if (errorFn != null) {
            errorFn(error)
        }

        if (complete != null) {
            complete(error);
        }
    })
}

export default {
    install: function (Vue) {
        Vue.prototype.requestApi = ({ url, method, data, qsFormat, then, fail, complete, loginStatus }) => requestApi({ url, method, data, qsFormat, then, fail, complete, loginStatus });
        Vue.prototype.ajax = ({ url, method, data, successFn, errorFn, complete, loginStatus }) => ajax({ url, method, data, successFn, errorFn, complete, loginStatus });
    }
}



// WEBPACK FOOTER //
// ./src/api/requestApi.js